export const CxoSidebarData = [
  {
    title: "Transaction Details",
    link: "transactionDetails",
  },
  {
    title: "Revenue Analysis",
    icon: "",
    subMenu: [
      {
        title: "Source Wise Analysis",
        path: "sourceWiseAnalysis",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "State Wise Analysis",
        path: "stateWiseAnalysis",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "All Product Wise Analysis",
        path: "productWiseAnalysis",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
  {
    title: "Lead Details",
    icon: "",
    subMenu: [
      {
        title: "All Source Details Leads",
        path: "registerdUser",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "All Source Leads Counts",
        path: "allsourceLead",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "State Wise Lead Count",
        path: "stateLead",
        cName: "sub-nav",
        icon: "",
      }
    ],
  },
  {
    title: "Stock Analysis",
    link: "stockAnalysis",
  },
  //   {
  //   title: "Product Order History",
  //   icon: "",
  //   link: "productOrderHistory",
  // },
  {
    title: "Selling Source Revenue Analysis",
    icon: "",
    link: "sellingSrcRevenueAnlysis",
  },

  {
    title: "Selling Source Wise Analysis",
    link: "sellingSourceWiseAnalysis",
  },
];
